import { TASK_LINK_FIELD_TYPES } from '@/constants/enums/CUSTOM_FIELDS_TYPES'

/**
 * Depends On and Required For are resolved per record and, outside the record
 * page and linked sections, the backend either refuses them on write or never
 * serves them. Pickers that build a column list use this to leave them out, so
 * an admin cannot configure something that quietly never works.
 */
export const isTaskDependencyColumn = (column?: { type?: string }|null): boolean => {
  return TASK_LINK_FIELD_TYPES.includes(column?.type)
}
